<template>
	<div class="link-radio" :class="classes" :style="styles" @click.stop="handleClick">
		<div class="link-radio-wrapper">
			<transition name="link-transition-scale" mode="out-in">
				<div class="link-radio-active-icon" v-if="currentValue" key="active">
					<slot name="active">
						<link-checkbox-inner status="check" v-if="radioActiveIcon === 'link-checkbox-inner-checked'" :disabled="radioDisabled"/>
						<link-checkbox-inner status="minus" v-else-if="radioActiveIcon === 'link-checkbox-inner-minus'" :disabled="radioDisabled"/>
						<link-radio-inner checked v-else-if="radioActiveIcon === 'link-radio-inner-checked'" :disabled="radioDisabled"/>
						<link-icon v-else :icon="radioActiveIcon"/>
					</slot>
				</div>
				<div class="link-radio-inactive-icon" v-else key="inactive">
					<slot name="inactive">
						<link-checkbox-inner status="uncheck" v-if="radioInactiveIcon === 'link-checkbox-inner-unchecked'" :disabled="radioDisabled"/>
						<link-checkbox-inner status="minus" v-else-if="radioActiveIcon === 'link-checkbox-inner-minus'" :disabled="radioDisabled"/>
						<link-radio-inner :checked="false" v-else-if="radioInactiveIcon === 'link-radio-inner-unchecked'" :disabled="radioDisabled"/>
						<link-icon v-else :icon="radioInactiveIcon"/>
					</slot>
				</div>
			</transition>
		</div>
		<span v-if="!!label" class="link-radio-label">{{label}}</span>
	</div>
</template>

<script>

    import LinkIcon from "../icon/link-icon";
    import {EditMixin} from "../mixins";

    const RADIO_SIZE = {
        default: 18,
        small: 14,
        large: 22,
    }

    export default {
        name: 'link-radio',
        mixins: [EditMixin],
        components: {LinkIcon},
        inject: {
            radioGroup: {
                default: null
            },
        },
        props: {
            value: {},

            val: {},
            label: {type: String},
            width: {type: [String, Number]},

            size: {default: 'small'},
            color: {type: String, default: 'primary',},
            activeIcon: {type: String,},
            inactiveIcon: {type: String,},
            activeColor: {type: String,},
            inactiveColor: {type: String},

            trueValue: {default: true},
            falseValue: {default: false},

            isCheckAllRadio: {type: Boolean},
        },
        watch: {
            value(val) {
                const curVal = this.currentValue ? this.trueValue : this.falseValue
                if (curVal !== val) {
                    this.currentValue = val === this.trueValue
                }
            },
            currentValue(val) {
                this.$emit('input', val ? this.trueValue : this.falseValue);
            },
        },
        data() {
            return {
                currentValue: this.value === this.trueValue,
            };
        },
        computed: {
            radioSize() {
                return (!!this.radioGroup && !!this.radioGroup.size) ? this.radioGroup.size : this.size;
            },
            radioColor() {
                return (!!this.radioGroup && !!this.radioGroup.color) ? this.radioGroup.color : this.color;
            },
            radioActiveIcon() {
                if (!this.radioGroup) {
                    return this.activeIcon || 'link-checkbox-inner-checked';
                } else {
                    return this.radioGroup.activeIcon || this.activeIcon || (!!this.radioGroup.multiple ? 'link-checkbox-inner-checked' : 'link-radio-inner-checked');
                }
            },
            radioInactiveIcon() {
                if (!this.radioGroup) return this.inactiveIcon || 'link-checkbox-inner-unchecked';
                else {
                    return this.radioGroup.inactiveIcon || this.inactiveIcon || (!!this.radioGroup.multiple ? 'link-checkbox-inner-unchecked' : 'link-radio-inner-unchecked');
                }
            },
            radioActiveColor() {
                return (!!this.radioGroup && !!this.radioGroup.activeColor) ? this.radioGroup.activeColor : this.activeColor;
            },
            radioInactiveColor() {
                return (!!this.radioGroup && !!this.radioGroup.inactiveColor) ? this.radioGroup.inactiveColor : this.inactiveColor;
            },
            radioDisabled() {
                return !!this.lv_disabled || (!!this.radioGroup && !!this.radioGroup.lv_disabled)
            },

            classes() {
                return [
                    `link-radio-color-${this.radioColor}`,
                    `link-radio-size-${this.radioSize}`,
                    {
                        'link-radio-disabled': this.radioDisabled,
                    }
                ];
            },
            styles() {
                let styles = {};
                !!this.radioSize && (styles.fontSize = `${RADIO_SIZE[this.radioSize]}px`);
                !!this.radioInactiveColor && (!this.currentValue) && (styles.color = `${this.radioInactiveColor} !important`);
                !!this.radioActiveColor && (!!this.currentValue) && (styles.color = `${this.radioActiveColor} !important`);

                if(!!this.width){
                    styles.width = this.$lv.$utils.unit(this.width)
				}
                return styles;
            },
        },
        methods: {
            handleClick(e) {
                this.$emit('click', e);
                if (this.lv_disabled || this.lv_readonly) return
                if (!!this.radioGroup) {
                    if (!!this.lv_disabled || !!this.lv_readonly || !!this.radioGroup.lv_disabled || !!this.radioGroup.lv_readonly) return;
                    if (!this.radioGroup.multiple) {
                        if (!!this.currentValue) return
                        this.radioGroup.radios.forEach(radio => radio !== this && (radio.currentValue = false))
                        this.radioGroup.singleValue = this.val
                    } else {
                        if (!this.currentValue) this.radioGroup.multipleValue.push(this.val);
                        else LinkUtils.removeFromArray(this.radioGroup.multipleValue, this.val);
                    }
                    this.currentValue = !this.currentValue;
                    this.$emit('change', this.currentValue);
                    this.radioGroup.handleChange()
                } else {
                    if (!!this.lv_disabled || !!this.lv_readonly) return;
                    this.currentValue = !this.currentValue;
                    this.$emit('change', this.currentValue);
                }
            },
        },
        created() {
            if (!!this.isCheckAllRadio) return;

            if (!!this.radioGroup) {
                this.radioGroup.addRadio(this)
                if (this.radioGroup.multiple) {
                    if (!this.val) {
                        console.error(`radio must have val when radio-group's multiple is true!`);
                        return;
                    }
                    this.currentValue = LinkUtils.oneOf(this.val, this.radioGroup.multipleValue);
                } else {
                    this.currentValue = this.radioGroup.singleValue === this.val;
                }
            }
        },
        destroyed() {
            !!this.radioGroup && (this.radioGroup.removeRadio(this));
        },
    };
</script>

<style lang="scss">
	@include themeify {
		.link-radio {
			cursor: pointer;
			box-sizing: border-box;
			display: inline-flex !important;
			vertical-align: middle;
			border: none;
			background: none;
			align-items: center;
			border-radius: $shape-fillet;
			user-select: none;
			height: 28px;
			line-height: 28px;

			@include pl-colors(link-radio) {
				color: $value;
			}

			.link-radio-label {
				display: inline-flex;
				align-items: center;
				margin-left: 0.5em;
				color: $color-normal-input;
				font-size: 12px;
			}

			.link-radio-wrapper {
				position: relative;
				display: inline-flex;
				align-items: center;
				width: 1em;
				height: 1em;
				user-select: none;

				.link-radio-active-icon, .link-radio-inactive-icon {
					width: 1em;
					height: 1em;
					transition: all 0.1s linear;
					position: relative;

					& > * {
						position: absolute;
						top: 0;
						bottom: 0;
						left: 0;
						right: 0;
					}
				}
			}

			&.link-radio-disabled {
				color: $color-info !important;

				.link-checkbox-inner {
					background-color: #f5f5f5;
					border-color: $placeholder-color;

					.link-checkbox-inner-check-polyline {
						stroke: #bfbfbf !important;
					}

					.link-checkbox-inner-minus-polyline {
						stroke: #bfbfbf !important;
					}
				}

				.link-radio-inner {
					color: #bfbfbf !important;
				}
			}
		}

		.link-radio-group {
			box-sizing: border-box;
			display: inline-flex;
			vertical-align: middle;
			border: none;
			background: none;
			align-items: center;

			&.link-radio-group-horizontal {
				.link-radio:not(:last-child) {
					margin-right: 20px;
				}
			}

			&.link-radio-group-vertical {
				flex-direction: column;

				.link-radio:not(:last-child) {
					margin-bottom: 20px;
				}
			}
		}
	}

</style>
